
import {
	getOrdersRequest,
	getOrdersByIdsRequest,
	getGeocodeOrdersRequest,
	getOrderTotalsRequest
} from '../requests';
import { baseUrl, cleanLocationTags, newUUID } from '@/core';
import searchFilterActions from './searchFilter/orderSearch.actions.js';

function setValue({ commit }, { value, key }) {
	commit('setValue', { value, key });
}

function cleanSearchFilter(searchFilter) {
	return {
		dateType: searchFilter.dateType || 'etd',
		date: searchFilter.date,
		fromDespatchParty: Array.isArray(searchFilter.fromDespatchParty) ? cleanLocationTags(searchFilter.fromDespatchParty) : null,
		toDeliveryParty: Array.isArray(searchFilter.toDeliveryParty) ? cleanLocationTags(searchFilter.toDeliveryParty) : null,
		customer: searchFilter.customer || [],
		goodsTypes: Array.isArray(searchFilter.goodsTypes) ? searchFilter.goodsTypes.map(x => x.tpxCode) : [],
		orderTypes: Array.isArray(searchFilter.orderTypes) ? searchFilter.orderTypes.map(x => x.r10Id) : [],
		hasAtd: searchFilter.hasAtd ? searchFilter.hasAtd.value : undefined,
		hasAta: searchFilter.hasAta ? searchFilter.hasAta.value : undefined,
		economicalStatus: Array.isArray(searchFilter.economicalStatus) ? searchFilter.economicalStatus : [],
		orderStatus: Array.isArray(searchFilter.orderStatus) ? searchFilter.orderStatus : [],
		references: Array.isArray(searchFilter.references) ? searchFilter.references.map (x => x.id) : [],
		referencesText: searchFilter.referencesText,
		waybillNumber: Array.isArray(searchFilter.waybillNumber) ? searchFilter.waybillNumber.map (x => x.id) : [],
		inboundEdi: searchFilter.mustHaveInboundEdi ? searchFilter.inboundEdi : null,
		mustHaveInboundEdi: searchFilter.mustHaveInboundEdi,
		mustHaveDeviation: searchFilter.mustHaveDeviation,
	};
}

async function fetchOrders({ dispatch, commit, state }) {
	commit('setValue', { value: true, key: 'ordersLoading' });
	commit('clearOrders');
	try {
		dispatch('fetchTotals');
		let currentSearch = newUUID();
		commit('setValue', { value: currentSearch, key: 'searchUUID' });
		let idData = await getOrdersRequest(cleanSearchFilter(state.searchFilter));
		let response = null;
		response = await getOrdersByIdsRequest(idData.splice(0,200).map(x => x.id));
		commit('updateMatchingOrders', response);
		commit('setValue', { value: false, key: 'ordersLoading' });

		while (idData.length > 0) {
			commit('setValue', { value: true, key: 'ordersFetching' });
			let response = await getOrdersByIdsRequest(idData.splice(0,500).map(x => x.id));
			if (state.searchUUID !== currentSearch) break;
			commit('updateMatchingOrders', response);
		}
	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('setValue', { value: false, key: 'ordersFetching' });
	commit('setValue', { value: false, key: 'ordersLoading' });
}

async function fetchTotals({ commit, state }) {
	try {
		let totals = await getOrderTotalsRequest(cleanSearchFilter(state.searchFilter));
		commit('setTotals', totals);
	} catch (err) {
		throw new Error('failedToFetch');
	}
}

function loadSavedSearch({ commit }, savedSearch) {
	if (savedSearch) commit('loadSavedSearch', savedSearch);
}

function setOrderDetails({ commit }, id) {
	commit('setOrderDetails', id);
}

function setOrderJson({ commit }, id) {
	commit('setOrderJsonId', id);
}

function getWaybill(_, orderIds) {
	let base = baseUrl();

	if (Array.isArray(orderIds) && orderIds.length > 1) {
		let form = document.createElement('form');
		form.target = '_blank';
		form.method = 'post';
		form.action = `${base}/documents/wayBill/merged`;
		form.style.display = 'none';

		let input = document.createElement('input');
		input.type = 'text';
		input.required = 'required';
		input.name = 'ids';
		input.value = orderIds;
		form.appendChild(input);

		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	} else {
		let url = `${base}/documents/wayBill/${orderIds}`;
		window.open(url);
	}
}

function getPackageLabel(_, orderIds) {
	let base = baseUrl();
	let locale = localStorage.getItem('locale');

	if (Array.isArray(orderIds) && orderIds.length > 1) {
		let form = document.createElement('form');
		form.target = '_blank';
		form.method = 'post';
		form.action = `${base}/documents/packageLabel/${locale}/merged`;
		form.style.display = 'none';

		let input = document.createElement('input');
		input.type = 'text';
		input.required = 'required';
		input.name = 'ids';
		input.value = orderIds;
		form.appendChild(input);

		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	} else {
		let url = `${base}/documents/packageLabel/${locale}/${orderIds}`;
		window.open(url);
	}
}

async function geocodeOrders({ commit }, orderIds) {
	commit('setValue', { value: true, key: 'geocoding' });
	try {
		let orders = await getGeocodeOrdersRequest(orderIds);
		commit('updateMatchingOrders', orders);
	} catch (err) {
		throw new Error('failedToGeocode');
	}
	commit('setValue', { value: false, key: 'geocoding' });
}

export default {
	...searchFilterActions,
	setValue,
	fetchOrders,
	fetchTotals,
	loadSavedSearch,
	setOrderDetails,
	setOrderJson,
	getWaybill,
	getPackageLabel,
	geocodeOrders
};
